import { SharedUiGapsName, type SharedUiGapsService } from '@/shared/ui/theming';
import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';

const designSystemGaps: Record<SharedUiGapsName, string> = {
    [SharedUiGapsName.GAP_0]: '0',
    [SharedUiGapsName.GAP_1]: '4px',
    [SharedUiGapsName.GAP_S]: '8px',
    [SharedUiGapsName.GAP_M]: '12px',
    [SharedUiGapsName.GAP_L]: '16px',
    [SharedUiGapsName.GAP_5]: '20px',
    [SharedUiGapsName.GAP_6]: '24px',
    [SharedUiGapsName.GAP_8]: '32px',
    [SharedUiGapsName.GAP_10]: '40px',
    [SharedUiGapsName.GAP_12]: '48px',
    [SharedUiGapsName.GAP_14]: '56px',
    [SharedUiGapsName.GAP_16]: '64px',
    [SharedUiGapsName.GAP_18]: '72px',
    [SharedUiGapsName.GAP_20]: '80px',
    [SharedUiGapsName.GAP_24]: '96px',
    [SharedUiGapsName.GAP_PAGE_BOUNDS]: '32px',
    [SharedUiGapsName.GAP_INTER_BLOCK]: '16px'
};

@Injectable({
    providedIn: 'root'
})
export class AdvizeoGapsService implements SharedUiGapsService {
    getGap$(sharedUiGapName: SharedUiGapsName): Observable<string> {
        return of(designSystemGaps[sharedUiGapName]);
    }
}
